import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";
import { Input } from "../ui/input";
import { applyFilters, emptyFilters } from "../../lib/adminApi";
import { supabase } from "../../lib/supabase";

export function ClientPicker({ client, onPick }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (client) return;
    const t = setTimeout(async () => {
      const query = applyFilters(supabase.from("admin_profile_list").select("id,full_name,registration_no,profile_for,age,status"), { ...emptyFilters, q }, { hasUser: true });
      const { data } = await query.order("created_at", { ascending: false }).limit(8);
      setRows(data || []);
    }, 250);
    return () => clearTimeout(t);
  }, [q, client]);

  if (client) {
    return (
      <div data-testid="selected-client" className="rmm-card flex flex-wrap items-center justify-between gap-3 p-4">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C59B27]">Sharing to client</p>
          <p className="font-display text-2xl font-bold text-[#4A000E]">{client.full_name} <span className="font-sans text-sm font-medium text-[#8C6A6C]">· {client.registration_no} · {client.profile_for}</span></p>
        </div>
        <button type="button" onClick={() => onPick(null)} data-testid="change-client-button" className="inline-flex items-center gap-1 rounded-full border border-[#D4AF37]/60 px-3 py-1.5 text-xs font-semibold text-[#7A0016] hover:bg-[#F5E6BA]/50"><X className="h-3.5 w-3.5" /> Change client</button>
      </div>
    );
  }
  return (
    <div className="rmm-card p-4" data-testid="client-picker">
      <p className="mb-2 text-sm font-semibold text-[#2C2424]">Step 1: pick the client to share profiles with</p>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#8C6A6C]" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search client by name, registration no., phone or email" data-testid="client-search-input" className="rmm-input h-10 bg-white pl-9" />
      </div>
      <ul className="mt-3 divide-y divide-[#D4AF37]/20">
        {rows.length === 0 && <li className="py-3 text-sm text-[#8C6A6C]">No clients found.</li>}
        {rows.map((r) => (
          <li key={r.id}>
            <button type="button" onClick={() => onPick(r)} data-testid={`pick-client-${r.id}`} className="flex w-full items-center justify-between gap-3 px-2 py-2.5 text-left text-sm hover:bg-[#F5E6BA]/40">
              <span className="font-semibold text-[#7A0016]">{r.full_name}</span>
              <span className="text-xs text-[#8C6A6C]">{r.registration_no} · {r.profile_for} · {r.age} yrs · {r.status}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
